import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import icon from '../Assets/image 82.png'
import SEOData from '../Components/SEOData'
function BasicInfo() {
  return (
    <>
        <Navbar/>
        <SEOData PageName={'basicinfo'} />
        <div className='BasicInfo'>
        <div className='BasicInfo-left'>
        <h3>Basic Information</h3>
        <br/>
        <div className='Basic-inps'>
        <input placeholder='First Name' />
        <input placeholder='last Name' />
        </div>
        <br/>
        <br/>
        <div className='Basic-inps'>
        <input placeholder='Email' />
        
        </div>
        <br/>
        <br/>
        <h3>Payment Method</h3>
        <br/>
        <br/>
        <div className='Payment-method'>
            <p>Google Pay</p>
        </div>
        <br/>
        <div className='Payment-method'>
            <p>Debit Card</p>
        </div>

</div>
  <div className='BasicInfo-right'>
  <div className='BasicInfo-total'>
  <div className='check-card'>
<img src={icon}/>
<div>
    <h4>Diamond Plan</h4>
    <h3>Rs 2999</h3>
</div>
  </div>
  <br/>
  <br/>
    <div className='PaymentDetails'>
    <h3>Payment Details</h3>
  <br/>

    <div className='order-div'>
    <h3>Order</h3>
    <h3>Rs2000.00</h3>

    </div>
    <br/>

<div className='order-div'>
<h3>Order</h3>
<h3>Rs2000.00</h3>

</div>
<br/>
<br/>
<div className='order-div'>
<h3>Order</h3>
<h3>Rs2000.00</h3>

</div>
<br/>
<br/>
<br/>
<div className='order-div'>
<h3>Order</h3>
<h3>Rs2000.00</h3>

</div>
<br/>
<br/>
<button>Pay Now</button>
    </div>


  </div>

</div>
        </div>
        <Footer/>
    </>
  )
}

export default BasicInfo